<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

    <the-customizer
      v-if                    = "!disableCustomizer"
      :footerType             = "footerType"
      :hideScrollToTop        = "hideScrollToTop"
      :navbarType             = "navbarType"
      :navbarColor            = "navbarColor"
      :routerTransition       = "routerTransition"
      @toggleHideScrollToTop  = "toggleHideScrollToTop"
      @updateFooter           = "updateFooter"
      @updateNavbar           = "updateNavbar"
      @updateNavbarColor      = "updateNavbarColor"
      @updateRouterTransition = "updateRouterTransition" />

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      :logo         = "navMenuLogo"
      title         = "Mitigarisk"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :logo         = "navMenuLogo"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
// import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheCustomizer       from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour
  },
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuLogo       : require('@/assets/images/logo/logo.png'),
      // navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [
        {
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        }
      ]
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    navMenuItems () {
      const user_role = JSON.parse(localStorage.getItem('userInfo')).role
      const token = localStorage.getItem('accessToken')
      window.getPrendTaCom.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
      window.getPrendTaCom.$http.defaults = JSON.parse(JSON.stringify(window.getPrendTaCom.$http.defaults))

      const dashboard = {
        url: '/dashboard',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon',
        i18n: 'Dashboard'
      } 
      const Utilisateurs = {
        url: '/Utilisateurs',
        name: 'Utilisateurs',
        icon: 'UserIcon',
        slug: 'Utilisateurs',
        i18n: 'Utilisateurs'
      }
      const Meetings = {
        url: '/Meetings',
        name: 'Meetings',
        icon: 'ClockIcon',
        slug: 'Meetings',
        i18n: 'meetings'
      }
      const Projects = {
        url: '/Projects',
        name: 'Projects',
        icon: 'TagIcon',
        slug: 'Projects',
        i18n: 'projects'
      }
      const Formations = {
        url: '/Formations',
        name: 'Formations',
        icon: 'Edit3Icon',
        slug: 'Formations',
        i18n: 'formations'
      }
      const Tasks = {
        url: '/Tasks',
        name: 'Tasks',
        icon: 'ClipboardIcon',
        slug: 'Tasks',
        i18n: 'tasks'
      }
      const Functions = {
        url: '/Functions',
        name: 'Functions',
        icon: 'BriefcaseIcon',
        slug: 'Functions',
        i18n: 'functions'
      } 
      const Vehicules = {
        url: '/Vehicules',
        name: 'Vehicules',
        icon: 'TruckIcon',
        slug: 'Vehicules',
        i18n: 'vehicles'
      } 
      /*  const Nationalities = {
        url: '/Nationalities',
        name: 'Nationalities',
        icon: 'FlagIcon',
        slug: 'Nationalities',
        i18n: 'nationalities'
      }  */
      const Sites = {
        url: '/Sites',
        name: 'Sites',
        icon: 'MapPinIcon',
        slug: 'Sites',
        i18n: 'sites'
      } 
      const Companies = {
        url: '/Companies',
        name: 'Companies',
        icon: 'GlobeIcon',
        slug: 'Companies',
        i18n: 'companies'
      } 

      const InsuranceCompanies = {
        url: '/InsuranceCompanies',
        name: 'InsuranceCompanies',
        icon: 'SquareIcon',
        slug: 'InsuranceCompanies',
        i18n: 'insuranceCompanies'
      } 

      const Equipments = {
        url: '/Equipments',
        name: 'Equipments',
        icon: 'LayersIcon',
        slug: 'Equipments',
        i18n: 'equipments'
      } 
      const LiftingEquipments = {
        url: '/LiftingEquipments',
        name: 'LiftingEquipments',
        icon: 'LayersIcon',
        slug: 'LiftingEquipments',
        i18n: 'liftingEquipments'
      } 
      const EquipmentTypes = {
        url: '/EquipmentTypes',
        name: 'EquipmentTypes',
        icon: 'LayersIcon',
        slug: 'EquipmentTypes',
        i18n: 'equipmentTypes'
      } 
      const Staffs = {
        url: '/Staffs',
        name: 'Staffs',
        icon: 'UserPlusIcon',
        slug: 'Staffs',
        i18n: 'staffs'
      } 
      const StaffHasEquipments = {
        url: '/StaffHasEquipments',
        name: 'StaffHasEquipments',
        icon: 'ToolIcon',
        slug: 'StaffHasEquipments',
        i18n: 'staffHasEquipments'
      } 
      const Teams = {
        url: '/Teams',
        name: 'Teams',
        icon: 'UsersIcon',
        slug: 'Teams',
        i18n: 'teams'
      } 
      /* const Missions = {
        url: '/Missions',
        name: 'Missions',
        icon: 'TargetIcon',
        slug: 'Missions',
        i18n: 'missions'
      }  */
      const Staff_Formations = {
        url: '/Staff_Formations',
        name: 'Staff_Formations',
        icon: 'ListIcon',
        slug: 'Staff_Formations',
        i18n: 'Staff_Formations'
      } 
      const Measures = {
        url: '/Measures',
        name: 'Measures',
        icon: 'AlertTriangleIcon',
        slug: 'Measures',
        i18n: 'measures'
      }
      const RiskProfiles = {
        url: '/RiskProfiles',
        name: 'RiskProfiles',
        icon: 'XSquareIcon',
        slug: 'RiskProfiles',
        i18n: 'riskProfiles'
      }
      /* const Journeys = {
        url: '/Journeys',
        name: 'Journeys',
        icon: 'WatchIcon',
        slug: 'Journeys',
        i18n: 'journeys'
      }  */ 
      /* const evacuationPlans = {
        url: '/EvacuationPlans',
        name: 'EvacuationPlans',
        icon: 'PhoneIcon',
        slug: 'EvacuationPlans',
        i18n: 'evacuationPlans'
      }   */
      const riskZones = {
        url: null,
        name: 'riskZones',
        icon: 'BarChart2Icon',
        i18n: 'riskZones',
        submenu: [
          {
            url: '/Categories',
            name: 'categories',
            slug: 'categories',
            i18n: 'categories'
          },
          {
            url: '/Questions',
            name: 'Questions',
            slug: 'Questions',
            i18n: 'questions'
          }/* ,
          {
            url: '/RiskZoneAssessments',
            name: 'RiskZoneAssessments',
            slug: 'RiskZoneAssessments',
            i18n: 'riskZoneAssessments'
          } */
        ]
      }
      const riskAssessments = {
        url: null,
        name: 'riskAssessments',
        icon: 'AlertCircleIcon',
        i18n: 'riskAssessments',
        submenu: [
          {
            url: '/Activities',
            name: 'Activities',
            slug: 'Activities',
            i18n: 'activities'
          },
          {
            url: '/Risks',
            name: 'Risks',
            slug: 'Risks',
            i18n: 'risks'
          }/* ,
          {
            url: '/JobRiskAssessments',
            name: 'JobRiskAssessments',
            slug: 'JobRiskAssessments',
            i18n: 'jobRiskAssessments'
          } */
        ]
      }
      const Bibliotheque = {
        url: '/Libraries',
        name: 'Libraries',
        icon: 'BookIcon',
        slug: 'Libraries',
        i18n: 'libraries'
      } 
      const Planifications = {
        url: '/Planifications',
        name: 'Planifications',
        icon: 'LinkIcon',
        slug: 'Planifications',
        i18n: 'planification'
      }

      const Validations = {
        url: '/Validations',
        name: 'Validations',
        icon: 'CheckCircleIcon',
        slug: 'Validations',
        i18n: 'validations'
      }

      const SecurityQuestions = {
        url: '/SecurityQuestions',
        name: 'SecurityQuestions',
        icon: 'TriangleIcon',
        slug: 'SecurityQuestions',
        i18n: 'securityQuestions'
      }

      const SecurityEvaluation = {
        url: '/SecurityEvaluations',
        name: 'SecurityEvaluations',
        icon: 'AlertTriangleIcon',
        slug: 'SecurityEvaluations',
        i18n: 'securityEvaluations'
      }

      const Reporting = {
        url: '/Reporting',
        name: 'Reporting',
        icon: 'FileTextIcon',
        slug: 'Reporting',
        i18n: 'reporting'
      }

      const Assignations = {
        url: '/Assignations',
        name: 'Assignations',
        icon: 'Share2Icon',
        slug: 'Assignation',
        i18n: 'Assignations'
      }


      let role = []
      
      const role_admin = [
        dashboard,
        Reporting,
        SecurityEvaluation,
        SecurityQuestions,
        Validations,
        Bibliotheque,
        Meetings,
        //evacuationPlans,
        //Journeys,
        Planifications,
        Projects,
        riskAssessments,
        riskZones,
        //Missions,
        Teams,
        Staff_Formations,
        StaffHasEquipments,
        Staffs,
        Measures,
        Tasks,
        RiskProfiles,
        Vehicules,
        EquipmentTypes,
        LiftingEquipments,
        Equipments,
        InsuranceCompanies,
        Companies,
        //Nationalities,
        //Zones,
        Sites,
        Functions,
        Formations,
        Utilisateurs

      ]
      const role_managerSubcontractor = [
        dashboard,
        Assignations,
        Planifications,
        //Missions,
        Teams,
        Staff_Formations,
        StaffHasEquipments,
        Staffs,
        Vehicules,
        LiftingEquipments,
        Equipments,
        Reporting       
      ]
      const role_qhsNokia = [
        dashboard,
        Validations,
        Planifications,
        Teams,
        Staff_Formations,
        StaffHasEquipments,
        Staffs,
        Vehicules,
        LiftingEquipments,
        Equipments,
        Formations,
        Sites
      ]
      const role_pessNokia = [
        dashboard,
        SecurityEvaluation,
        SecurityQuestions, 
        Validations, 
        Planifications,
        riskAssessments,
        riskZones,
        Teams,
        Staff_Formations,
        StaffHasEquipments,
        Staffs,
        Vehicules,
        LiftingEquipments,
        Equipments,
        Formations,
        Sites
      ]
      const role_teamLeaderSubcontractor = [Reporting, Planifications]
      const role_nokiaProject = [Planifications]
      const role_room = [dashboard, Assignations, Planifications, Sites]
      const role_leadProject = [dashboard, Validations, Planifications, Sites]
     

      if (user_role === 'admin') {
        role = role_admin
      }
      if (user_role === 'managerSubcontractor') {
        role = role_managerSubcontractor
      }
      if (user_role === 'teamLeaderSubcontractor') {
        role = role_teamLeaderSubcontractor
      }
      if (user_role === 'qhsNokia') {
        role = role_qhsNokia
      }
      if (user_role === 'nokiaProject') {
        role = role_nokiaProject
      }
      if (user_role === 'pessNokia') {
        role = role_pessNokia
      }
      if (user_role === 'rom') {
        role = role_room
      }
      if (user_role === 'leadProject') {
        role = role_leadProject
      }
      return role
    },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>

